import React from "react"
import Cabecalho from "../Cabecalho"
import { ListaVersoes } from "./components/ListaVersoes"

export function HistoricoVersoes() {
    return (
        <>
            <Cabecalho pagina="Histórico de Versões" />
            <ListaVersoes />
        </>
    )
}
